import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Backdrop,
  Button,
  Chip,
  CircularProgress,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { Box, palette } from "@mui/system";
import DataGridComponent from "../../components/DataGridComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteBrand, listBrand } from "../../actions/brandActions";
import {
  Create,
  DeleteOutline,
  ModeEditOutlineOutlined,
  ViewAgendaOutlined,
} from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { toast } from "react-toastify";
import { BRAND_DELETE_RESET } from "../../constants/brandConstants";

export default function BrandList() {
  const { palette } = useTheme();
  const columns = [
    {
      field: "_id",
      headerName: "ID",
      width: 200,
      renderCell: (params) => {
        return <> {params.row._id} </>;
      },
    },
    {
      field: "name",
      width: 200,
      headerName: "Name",
      renderCell: (params) => {
        return <> {params.row.name} </>;
      },
    },

    {
      field: "status",
      headerName: "Active",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            {" "}
            {params.row.status ? (
              <Typography variant="body2" color="primary">
                Active
              </Typography>
            ) : (
              <Typography variant="body2" color="red">
                Not Active
              </Typography>
            )}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <Link href={`/brand/${params.row._id}`}>
              <ModeEditOutlineOutlined
                style={{
                  color: palette.primary.main,
                  cursor: "pointer",
                  marginRight: "10px",
                }}
              />
            </Link>
            <DeleteOutline
              className="delIcon"
              sx={{
                cursor: "pointer",
                color: palette.error.main,
              }}
              onClick={() => handleDelete(params.row._id)}
            />
          </>
        );
      },
    },
  ];

  const dispatch = useDispatch();

  const brandList = useSelector((state) => state.brandList);
  const { loading, error, brands } = brandList;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const brandDelete = useSelector((state) => state.brandDelete);
  const { success } = brandDelete;

  React.useEffect(() => {
    dispatch(listBrand());
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if(success){
      toast("Brand deleted successfully");
      dispatch({ type: BRAND_DELETE_RESET });
    }
  }, [dispatch, userInfo, success]);

  const navigate = useNavigate();

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete the Brand?")) {
      dispatch(deleteBrand(id));
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}

        {error && (
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        )}

        {brands && (
          <DataGridComponent
            buttonTitle={"Add Brand"}
            onClick={() => navigate("/addbrand")}
            title={"Brand List"}
            columns={columns}
            rows={brands}
          />
        )}
      </Grid>
    </Grid>
  );
}
